import { Pipe, PipeTransform } from '@angular/core';
import { Train } from '../models/train';

@Pipe({
  name: 'filterTrain'
})
export class FilterTrainPipe implements PipeTransform {

  transform(trains: Train[], types?: string[], maintainers?: string[] ): unknown {
    return types || maintainers ? trains && trains.filter(train => {
      if (maintainers && types) {
        const isTypeSelected = types.length > 0 ? !!types.find(type => (train.displayTypeName || train.trainType).toLowerCase() === type.toLowerCase()) : true;
        const isMaintainerSelected = maintainers.length > 0 ? !!maintainers.find(maintainer => train.maintainer.toLowerCase() === maintainer.toLowerCase()) : true
        return isTypeSelected && isMaintainerSelected;
      } else {
        if (types && types.length > 0) {
          return !!types.find(type => train.trainType.toLowerCase() === type.toLowerCase())
        }
        if (maintainers && maintainers.length > 0 ) {
          return !!maintainers.find(maintainer => train.maintainer.toLowerCase() === maintainer.toLowerCase())
        }
        return true;
      }
    })  : trains;
  }

}
